import { createHelpers } from "vuex-map-fields";
import { axiosCall } from "../../utils/axiosCall";

const { getOpinionSurveyField, updateOpinionSurveyField } = createHelpers({
  getterType: "getOpinionSurveyField",
  mutationType: "updateOpinionSurveyField",
});

function initialState() {
  return {
    status: {
      opinionSurvey: "",
    },
    opinionSurvey: {},
    sections: [],
    currentSection: "",
    currentQuestion: "",
    currentQuestionName: "",
    currentFilterCriteria: "",
  };
}

const state = initialState;
const sectionOrder = [
  "label_opinionSurvey_opinionsAboutGender_title",
  "label_opinionSurvey_recruitment_title",
  "label_opinionSurvey_growth_title",
  "label_opinionSurvey_training_title",
  "label_opinionSurvey_remuneration_title",
  "label_opinionSurvey_workFamilyBalance_title",
  "label_opinionSurvey_communication_title",
  "label_opinionSurvey_workEnvironment_title",
  "label_opinionSurvey_harassment_title",
];
const getters = {
  getCurrentFilterCriteria: (state) => state.currentFilterCriteria,
  getOpinionSurvey: (state) => state.opinionSurvey,
  getOpinionSurveyFilteredSections: (state) => {
    const s = state.opinionSurvey.sections;
    const sections = [];
    if (s) {
      s.map((section) => {
        let dataLength = 0;
        section.questions.map((question) => {
          question.filterCriteria.map((filterCriteria) => {
            dataLength =
              dataLength + filterCriteria.participationChart.data.length;
          });
        });

        if (dataLength > 0) {
          sections.push(section.name);
        }
      });
    }
    sections.sort((a, b) => {
      const indexA = sectionOrder.findIndex((section) => section === a);
      const indexB = sectionOrder.findIndex((section) => section === b);
      return indexA - indexB;
    });
    return sections;
  },
  getOpinionSurveyCurrentSection: (state) => state.currentSection,
  getQuestionsBySection: (state) => (section) => {
    var questions = [];
    try {
      state.opinionSurvey.sections.map((i) => {
        if (i.name === section) {
          i.questions.map((j) => {
            let dataLength = 0;
            const questionN = j.name.split("_")[3];
            j.filterCriteria.map((filterCriteria) => {
              dataLength =
                dataLength + filterCriteria.participationChart.data.length;
            });
            if (dataLength > 0 && questionN !== "qSH2") {
              questions.push(j.name);
            }
          });
        }
      });
    } catch (e) {
      console.error(e);
    }
    return questions;
  },
  getQuestionsCompleteBySection: (state) => (section) => {
    var questions = [];
    state.opinionSurvey.sections.map((i) => {
      if (i.name === section) {
        i.questions.map((j) => {
          let dataLength = 0;
          const questionN = j.name.split("_")[3];
          j.filterCriteria.map((filterCriteria) => {
            dataLength =
              dataLength + filterCriteria.participationChart.data.length;
          });
          if (dataLength > 0 && questionN !== "qSH2") {
            questions.push(j);
            console.log("Questioncritery");
            console.log(j);
          }
        });
      }
    });
    return questions;
  },
  getFilterCriteriaByQuestion: (state) => (question) => {
    var groups = [];
    try {
      state.opinionSurvey.sections.map((i) => {
        i.questions.map((j) => {
          if (j.name === question) {
            j.filterCriteria.map((k) => {
              if (k.participationChart.data.length > 0) {
                groups.push(k.name);
              }
            });
          }
        });
      });
    } catch (e) {
      console.error(e);
    }
    return groups;
  },
  getOpinionSurveyCurrentQuestion: (state) => state.currentQuestion,
  getOpinionSurveyCurrentQuestionName: (state) => state.currentQuestionName,
  getOpinionSurveyQuestionData:
    (state) => (section, question, filterCriteria) => {
      const s = state.opinionSurvey.sections.find((x) => x.name === section);
      const q = s.questions.find((x) => x.name === question);
      const fc = q.filterCriteria.find((x) => x.name === filterCriteria);
      return fc;
    },
  getOpinionSurveyQuestionIsEmpty: (state) => {
    try {
      if (typeof state.opinionSurvey === "undefined") {
        console.log("vacio");
        return true;
      }

      let s; // state.opinionSurvey.sections.find(x => x.name === state.currentSection)
      state.opinionSurvey.sections.map((x) => {
        if (x.name === state.currentSection) {
          console.log("METE S");
          s = x;
          console.log(s);
        }
      });
      let q; // s.questions.find(x => x.name === state.currentQuestionName)
      s.questions.map((x) => {
        if (x.name === state.currentQuestionName) {
          q = x;
        }
      });

      if (typeof q === "undefined") {
        return true;
      }
      const fc = q.filterCriteria.find(
        (x) => x.name === state.currentFilterCriteria
      );
      if (typeof fc.responsesChart.data === "undefined") {
        return true;
      }
      return false;
    } catch (e) {
      return false;
    }
  },
  getOpinionSurveyField,
};

const actions = {
  OPINION_SURVEY_GET: ({ commit, rootState }) => {
    return new Promise((resolve, reject) => {
      commit("setOpinionSurveyStatus", {
        status: "pending",
        key: "opinionSurvey",
      });
      const companyId = rootState.business.currentBusiness.id;
      const snapshotId = rootState.business.currentSnapshot.snapshotId;
      console.log(
        "OpinionSurveys/report/" + companyId + "/?snapshot=" + snapshotId
      );
      axiosCall({
        url: "OpinionSurveys/report/" + companyId + "/?snapshot=" + snapshotId,
      })
        .then((resp) => {
          commit("setOpinionSurveyStatus", {
            status: "success",
            key: "opinionSurvey",
          });
          commit("setOpinionSurvey", resp.data);
          commit("setOpinionSurveyCurrentData");
          resolve();
        })
        .catch((err) => {
          reject(err);
          commit("setOpinionSurveyStatus", {
            status: "error",
            key: "opinionSurvey",
          });
        });
    });
  },
  OPINION_SURVEY_GET_REPORT: ({ commit, dispatch, state, rootState }) => {
    return new Promise((resolve, reject) => {
      // commit('setOpinionSurveyStatus', { status: 'pending', key: 'opinionSurvey' })
      const companyId = rootState.business.currentBusiness.id;
      const snapshotId = rootState.business.currentSnapshot.snapshotId;
      commit("setBusinessStatus", { status: "pending", key: "business" });
      commit("setBusinessStatus", { status: "pending", key: "snapshots" });
      commit("setAssessmentStatus", { status: "pending", key: "assessment" });
      commit("setSurveyStatus", "adding");
      commit("setOpinionSurveyStatus", {
        status: "pending",
        key: "opinionSurvey",
      });

      axiosCall({
        url:
          "OpinionSurveys/opinionSurveyReport/" +
          companyId +
          "/?snapshot=" +
          snapshotId,
      })
        .then((resp) => {
          /* GET SNAPSHOT */
          commit("setBusinessStatus", { status: "success", key: "snapshots" });
          commit("setSnapshots", resp.data.snapshotsData);
          /* GET BUSINESS */
          commit("setBusinessStatus", { status: "success", key: "business" });
          commit("setBusiness", resp.data.businessData);
          console.log("empiza");
          /* GET SELF ASSESMENT*/
          commit("setAssessmentStatus", {
            status: "success",
            key: "assessment",
          });
          if (resp.data.selfAssessmentData) {
            console.log("usar resp.data.selfAssessment......");
            commit("setSelfAssessment", resp.data.selfAssessmentData);
            /* dispatch('SET_DEFAULT_SELF_ASSESSMENT_FIELDS_GENERAL_INFORMATION')
              dispatch('SET_DEFAULT_SELF_ASSESSMENT_FIELDS_STAFF_RESPONSABILITY')
            dispatch('SET_DEFAULT_SELF_ASSESSMENT_LABOR_CONDITIONS')*/
            commit("setEmploymentPolicies", resp.data.employmentPoliciesData);
            // commit('organizeEmploymentPolicies')
          } else {
            console.log("usar state.selfAssessmentDefaultData");
            var tempSelfAssessment = state.selfAssessmentDefaultData;
            tempSelfAssessment.snapshotId = snapshotId;
            dispatch("SELF_ASSESSMENT_INITIAL_VALUES", tempSelfAssessment);
            dispatch("SELF_ASSESSMENT_UPDATE", tempSelfAssessment)
              .then(() => {
                commit("setSelfAssessment", tempSelfAssessment);
              })
              .catch((err) => {
                console.log(err);
              });
          }
          /* SURVEY */
          commit("setOpinionSurveyStatus", {
            status: "success",
            key: "opinionSurvey",
          });
          commit("setOpinionSurvey", resp.data.surveyData);
          commit("setOpinionSurveyCurrentData");
          /* INVITATIONS */
          commit("setSurveyStatus", "success");
          /*          commit('setInvitations', resp.data.invitationsData)*/

          /* await dispatch('SNAPSHOTS_GET')
          await dispatch('BUSINESS_GET')
          await dispatch('SELF_ASSESSMENT_GET')
          await dispatch('OPTION_LIST_GET') ???
          await dispatch('COUNTRIES_GET') ???
          await dispatch('INVITATIONS_GET')*/

          resolve();
        })
        .catch((err) => {
          reject(err);
          commit("setOpinionSurveyStatus", {
            status: "error",
            key: "opinionSurvey",
          });
        });
    });
  },
};

const mutations = {
  setCurrentFilterCriteria: (state, currentFilterCriteria) => {
    state.currentFilterCriteria = currentFilterCriteria;
  },
  setOpinionSurveyStatus: (state, data) => {
    state.status[data.key] = data.status;
  },
  setOpinionSurvey: (state, resp) => {
    state.opinionSurvey = resp;
    state.sections = [];
    resp.sections.map((i) => {
      state.sections.push(i.name);
    });
  },
  setOpinionSurveyCurrentData: (state) => {
    console.log("setOpinionSurveyCurrentData");
    state.currentSection = state.sections[0];
    state.currentQuestionName =
      state.opinionSurvey.sections[0].questions[0].name;
    state.currentQuestion =
      state.opinionSurvey.sections[0].questions[0].question;
    state.currentFilterCriteria =
      state.opinionSurvey.sections[0].questions[0].filterCriteria[0].name;
  },
  updateOpinionSurveyCurrentSection: (state, value) => {
    state.currentSection = value.section;
    const s = state.opinionSurvey.sections.find(
      (x) => x.name === value.section
    );
    const questions = s.questions.filter((q) => {
      return value.filteredQuestions.includes(q.name);
    });

    if (questions.length > 0) {
      state.currentQuestionName = questions[0].name;
      state.currentQuestion = questions[0].question;
      state.currentFilterCriteria = questions[0].filterCriteria[0].name;
    }
  },
  updateOpinionSurveyCurrentQuestionName: (state, questionName) => {
    const s = state.opinionSurvey.sections.find(
      (x) => x.name === state.currentSection
    );
    const q = s.questions.find((x) => x.name === questionName);
    state.currentQuestion = q.question;
    state.currentFilterCriteria = q.filterCriteria[0].name;
  },
  updateOpinionSurveyField,
  opinionSurveyReset: (state) => {
    const s = initialState();
    Object.keys(s).forEach((key) => {
      state[key] = s[key];
    });
  },
};

export default {
  state,
  getters,
  actions,
  mutations,
};
